module.exports = __webpack_public_path__ + "static/media/add.1464da81.svg";